import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import styled from "styled-components";

import { fadeIn } from "./Animations";

export const FadingRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            return (
                <PageTransition key={props.match.path}>
                    <Component />
                </PageTransition>
            );
        }}
    />
);

const PageTransition = styled.div`
    animation: ${fadeIn} 0.3s ease-in-out;

    @media (prefers-reduced-motion) {
        animation: none;
    }
`;

FadingRoute.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    match: PropTypes.shape({
        path: PropTypes.string
    })
};
